import React, { Suspense } from 'react';
import { SmartPatientDetails } from './SmartPatientDetails';
import { Skeleton } from './Skeleton';

const Header = React.lazy(() => import('./layout/Header').then(m => ({ default: m.Header })));
const WorkingHours = React.lazy(() => import('./layout/WorkingHours').then(m => ({ default: m.WorkingHours })));
const Footer = React.lazy(() => import('./layout/Footer').then(m => ({ default: m.Footer })));

interface LayoutProps {
  children: React.ReactNode;
}

const HeaderSkeleton = () => (
  <div className="w-full bg-white border-b border-gray-100">
    <div className="max-w-6xl mx-auto px-4 py-3">
      <Skeleton lines={2} />
    </div>
  </div>
);

export const SmartBookingLayout = ({ children }: LayoutProps) => {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Suspense fallback={<HeaderSkeleton />}>
        <Header />
      </Suspense>
      
      <div className="flex-1 max-w-6xl mx-auto w-full px-4 py-6">
        <div className="flex flex-col lg:grid lg:grid-cols-10 gap-6">
          <div className="lg:col-span-2">
            <SmartPatientDetails />
          </div>
          <main className="lg:col-span-8">
            {children}
          </main>
        </div>
      </div>
      
      <Suspense fallback={null}>
        <WorkingHours />
        <Footer />
      </Suspense>
    </div>
  );
};